import { render, staticRenderFns } from "./MultiGenesTrack.vue?vue&type=template&id=21e94a41&"
import script from "./MultiGenesTrack.vue?vue&type=script&lang=js&"
export * from "./MultiGenesTrack.vue?vue&type=script&lang=js&"
import style0 from "./MultiGenesTrack.vue?vue&type=style&index=0&id=21e94a41&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e94a41')) {
      api.createRecord('21e94a41', component.options)
    } else {
      api.reload('21e94a41', component.options)
    }
    module.hot.accept("./MultiGenesTrack.vue?vue&type=template&id=21e94a41&", function () {
      api.rerender('21e94a41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/multiSectionComponents/MultiGenesTrack.vue"
export default component.exports